import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import VariablePie from "highcharts/modules/variable-pie";

VariablePie(Highcharts);
function prepareData(rawData = []) {
  return rawData.map((item) => ({
    ...item,
    z: item.z ?? Math.sqrt(item.y),
  }));
}

const VariablePieChart = ({ title = "", newdata = [] }) => {
  const data = prepareData(newdata.length ? newdata : []);

  const chartOptions = {
    chart: {
      type: "variablepie",
    },
    title: {
      text: title,
    },
    tooltip: {
      headerFormat: "",
      pointFormat:
        '<span style="color:{point.color}">\u25CF</span> <b>{point.name}</b><br/>' +
        "Value: <b>{point.y}</b><br/>",
    },
    series: [
      {
        minPointSize: 10,
        innerSize: "20%",
        zMin: 0,
        name: "data",
        borderRadius: 5,
        data: data,
        colors: [
          "#00c179",
          "#3dc3e8",
          "#2dd9db",
          "#1feeaf",
          "#0ff3a0",
          "#00e887",
          "#82d056",
        ],
      },
    ],
    credits: { enabled: false },
    legend: { enabled: false },
  };

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <HighchartsReact
        highcharts={Highcharts}
        options={chartOptions}
        containerProps={{ style: { height: "400px", width: "100%" } }}
      />
    </div>
  );
};

export default VariablePieChart;
